export default "__VITE_ASSET__BwqOvM12__"